export default __webpack_public_path__ + "static/media/partner-WHO.0105ada3.svg";